import { render, staticRenderFns } from "./cart_summary.vue?vue&type=template&id=a1d2929a"
import script from "./cart_summary.vue?vue&type=script&lang=js"
export * from "./cart_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1d2929a')) {
      api.createRecord('a1d2929a', component.options)
    } else {
      api.reload('a1d2929a', component.options)
    }
    module.hot.accept("./cart_summary.vue?vue&type=template&id=a1d2929a", function () {
      api.rerender('a1d2929a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/cart_summary.vue"
export default component.exports